import React, { useEffect, useState } from "react";
import QyqwHeader from "../Component/QyqwHeader";
import { useNavigate } from "react-router-dom";
import { queryQes } from "../../../service";
import "./inedx.scss";

export default function QZCG() {
  const [sub, setSub] = useState(false);
  const [quesItem, setQuesItem] = useState(0);
  //用户答对题数
  const [userQues, setUserQues] = useState(0);
  //存储用户选择的答案
  const [userSel, setUserSel] = useState("");
  const [result, setResult] = useState(false);

  const [arr, setDataArr] = useState([]);

  //选项枚举
  const selectEnmu = {
    0: "A",
    1: "B",
    2: "C",
    3: "D",
  };

  const navigate = useNavigate();

  useEffect(() => {
    getQes();
  }, []);

  const getQes = () => {
    queryQes().then((res) => {
      if (res.records) {
        let s = [];
        let j = [];
        res.records?.map((item) => {
          let answer = 0;

          if (Number(item.question.type) === 1) {
            const select = item.options.map((item1, index) => {
              if (item1.answerId === item.question.answerId) answer = index;
              return item1.title;
            });
            const q = {
              title: item.question.title,
              select: select,
              isSelect: true,
              answer: answer,
              img: item.question.img,
            };
            s.push(q);
            return q;
          } else if (Number(item.question.type) === 3) {
            item.options.map((item1, index) => {
              if (item1.answerId === item.question.answerId) answer = index;
              return item1;
            });
            const q = {
              title: item.question.title,
              isSelect: false,
              answer: answer,
              img: item.question.img,
            };
            j.push(q);
            return q;
          } else return 0;
        });
        const newData2 = s.concat(j).map((item, index) => {
          return { ...item, title: index + 1 + "、" + item.title };
        });
        console.log("newData2", newData2);
        setDataArr(newData2);
      }
    });
  };

  //清楚选中的样式
  const clearSelectStyle = () => {
    const elArr = document.getElementsByClassName("item");
    Array.prototype.forEach.call(elArr, (el, index) => {
      document.getElementsByClassName("item")[index].removeAttribute("style");
      // console.log('遍历元素', el, index);
    });
    document.getElementsByClassName("A").length > 0 &&
      document.getElementsByClassName("A")[0].removeAttribute("style");
    document.getElementsByClassName("B").length > 0 &&
      document.getElementsByClassName("B")[0].removeAttribute("style");
    document.getElementsByClassName("C").length > 0 &&
      document.getElementsByClassName("C")[0].removeAttribute("style");
    document.getElementsByClassName("D").length > 0 &&
      document.getElementsByClassName("D")[0].removeAttribute("style");
  };

  const selectItem = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!sub) {
      clearSelectStyle();

      document.getElementById(e.target.id).style.border = "1px solid #f4ae39";
      document.getElementById(e.target.id).style.backgroundColor = `rgba(
      243, 151, 0, 0.1
      )`;
      setUserSel(e.target.id);
    }
  };

  const checkAnswer = () => {
    setSub(true);

    //将正确答案置绿
    //获取正确答案
    const answer = selectEnmu[arr[quesItem]?.answer];
    // console.log('获取答案', answer);

    document.getElementById(answer).style.border = "1px solid #5cbd46";
    document.getElementById(answer).style.backgroundColor = `rgba(
      76,
      175,
      80,
      0.1
    )`;
    if (document.getElementsByClassName(answer).length > 0) {
      document.getElementsByClassName(answer)[0].style.display = "inline-block";
    }

    //存储用户对错题数
    if (userSel === answer) {
      setUserQues(userQues + 1);
      // console.log('用户答对题数', userQues);
    } else {
      //用户答错
      if (document.getElementsByClassName(userSel).length > 0) {
        document.getElementsByClassName(userSel)[0].style.display =
          "inline-block";
      }
    }
    //标记已答 且用户选择答案
    const newArr = [...arr];

    newArr[quesItem].Done = true;
    const keyArr = Object.keys(selectEnmu);
    let userSelValue = -1;
    keyArr.map((key) => {
      if (selectEnmu[key] === userSel) {
        userSelValue = key;
      }
      return key;
    });
    newArr[quesItem].userAnswer = Number(userSelValue);
    setDataArr(newArr);
    // console.log('用户提交答案', arr);
  };

  const nextQuestion = () => {
    // clearTimeout(timeRef.current);

    //如果最后一题 quesItem===9 出结果
    //.......展示结果页
    if (quesItem === arr.length - 1) setResult(true);
    else {
      //重置倒计时
      // setTime(15);
      //切换按钮
      setSub(false);
      setUserSel("");
      //切换下一题
      setQuesItem(quesItem + 1);

      //清除样式
      clearSelectStyle();
    }
  };

  const againQus = () => {
    //重新答题
    refreshPage();
  };

  const refreshPage = () => {
    setResult(false);

    setSub(false);
    setQuesItem(0);
    setUserQues(0);
    setUserSel("");
    getQes();
  };

  // const toIndex = () => {
  //   refreshPage();
  // };

  return (
    <div className="qzcg-page">
      <QyqwHeader title="琴智闯关" to="/GQKP" />
      {result ? (
        // className={userQues > 6 ? "App2 succApp" : "App2 failApp"}
        <div className={userQues > 0 ? "App2 succApp" : "App2 failApp"}>
          {/* <div className="return" onClick={toIndex}></div> */}
          <div className="successContent">
            <div className="sucessQues">答对 {userQues} 题</div>
            {/* <div className="quesTime">
              <img
                src={require("../../assets/images/QZWD/timeIcon.png")}
                alt="timeIcon"
                style={{
                  width: "1.8rem",
                  height: "1.8rem",
                  verticalAlign: "text-top",
                  marginRight: "0.8rem",
                }}
              />
              <span> 用时 {allTime} 秒</span>
            </div> */}
            {/* <div className="sucessTitle">
              {userQues > 6 ? "挑战成功，棒棒哒!" : "别灰心，再挑战一次!"}
            </div> */}
          </div>
          <div className="btn">
            <span className="btnS again" onClick={againQus}></span>
            <span
              className="btnS exit"
              onClick={() => navigate("/GQKP")}
            ></span>
          </div>
        </div>
      ) : (
        <>
          {arr.length > 0 && (
            <div className="Ques">
              <div className="content">
                <div className="title">{arr[quesItem].title}</div>
                <div className="sel">
                  {arr[quesItem].isSelect ? (
                    arr[quesItem].select.map((item, index) => {
                      if (index === arr[quesItem].answer) {
                        return (
                          <div
                            className="item"
                            id={selectEnmu[index]}
                            key={selectEnmu[index]}
                            onClick={(e) => selectItem(e)}
                          >
                            {selectEnmu[index]} {item}
                            <span
                              className={`${selectEnmu[index]} iconTrue`}
                            ></span>
                          </div>
                        );
                      }

                      return (
                        <div
                          className="item"
                          id={selectEnmu[index]}
                          key={selectEnmu[index]}
                          onClick={(e) => selectItem(e)}
                        >
                          {selectEnmu[index]} {item}
                          <span
                            className={`${selectEnmu[index]} iconFalse`}
                          ></span>
                        </div>
                      );
                    })
                  ) : (
                    <div className="jus">
                      <div
                        className="item"
                        id="A"
                        onClick={(e) => selectItem(e)}
                      >
                        {0 === arr[quesItem].answer && (
                          <span className={`${selectEnmu[0]} iconTrue`}></span>
                        )}
                        <span className={`${selectEnmu[0]} iconFalse`}></span>
                        正确
                      </div>
                      <div
                        className="item"
                        id="B"
                        onClick={(e) => selectItem(e)}
                      >
                        {1 === arr[quesItem].answer && (
                          <span className={`${selectEnmu[1]} iconTrue`}></span>
                        )}
                        <span className={`${selectEnmu[1]} iconFalse`}></span>
                        错误
                      </div>
                    </div>
                  )}
                </div>
                <div className="quesNum">
                  {quesItem + 1}/{arr.length}
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                {!sub ? (
                  <div className="sumbit" onClick={checkAnswer}></div>
                ) : (
                  <div className="next" onClick={nextQuestion}></div>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
